// Adapts the server test-run to the TestRunDrawer's shape, and builds the sample
// trigger data to send.
//
// The drawer expects: { trigger: {label, data, configured}, steps: [{id, label, kind,
// status, inputs, outputs, errors}] }. The server returns an ExecutionResponse:
// { id, status, triggerSnapshot, steps: [{nodeKey, kind, status, output, errorMessage}] }.

// Build the sample trigger data the server should run with, from the trigger node's
// catalog outputs (each has a `sample` and a fully-qualified `path` like "arbox.email").
// Produces { namespace: { field: sample } }, e.g. { arbox: { email: "...", user_role: "client" } }.
export function sampleTriggerData(nodes) {
    const trigger = nodes.find(n => n.type === "trigger");
    const outputs = trigger?.data?.trigger?.outputs || [];
    const data = {};
    outputs.forEach(o => {
        if (!o.path) return;
        const dot = o.path.indexOf(".");
        if (dot < 0) return;
        const ns = o.path.slice(0, dot);
        const field = o.path.slice(dot + 1);
        data[ns] = data[ns] || {};
        data[ns][field] = o.sample;
    });
    return data;
}

// Map the server ExecutionResponse → the drawer result shape.
export function adaptExecutionToDrawer(execution, nodes) {
    const trigger = nodes.find(n => n.type === "trigger");
    const triggerSpec = trigger?.data?.trigger;

    // Flatten the snapshot ({arbox:{email}}) to dotted keys for the drawer's KV grid.
    const flatData = {};
    const snap = execution?.triggerSnapshot || {};
    Object.entries(snap).forEach(([ns, obj]) => {
        if (obj && typeof obj === "object") {
            Object.entries(obj).forEach(([k, v]) => { flatData[`${ns}.${k}`] = v; });
        } else {
            flatData[ns] = obj;
        }
    });

    const steps = (execution?.steps || []).map(s => ({
        id: s.nodeKey,
        label: s.kind,
        kind: s.kind,
        status: s.status,   // SUCCESS | FAILED | SKIPPED (drawer also knows STOPPED, but server uses SKIPPED)
        inputs: [],
        outputs: s.output || null,
        errors: s.errorMessage ? [s.errorMessage] : [],
    }));

    return {
        trigger: {
            label: triggerSpec?.label || "טריגר",
            data: flatData,
            configured: Boolean(triggerSpec),
        },
        steps,
    };
}
